import * as Sentry from "@sentry/react";
import { RouterProvider } from "@tanstack/react-router";
import "./globals.css";
import "./libs/i18n/i18n";
import "./libs/nativewind/setup";
import { getRouter } from "./router";

// Initialize Sentry
if (import.meta.env.VITE_SENTRY_DSN && import.meta.env.VITE_SENTRY_ENABLED === "true") {
	Sentry.init({
		dsn: import.meta.env.VITE_SENTRY_DSN,
		environment: import.meta.env.MODE,
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration({
				maskAllText: true,
				blockAllMedia: true,
			}),
		],
		tracesSampleRate: 1.0,
	});
}

// Initialize Segment Analytics
if (import.meta.env.VITE_TRACKING === "true" && import.meta.env.MODE !== "development") {
	const script = document.createElement("script");
	script.innerHTML = `!function(){var i="analytics",analytics=window[i]=window[i]||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","screen","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware","register"];analytics.factory=function(e){return function(){if(window[i].initialized)return window[i][e].apply(window[i],arguments);var n=Array.prototype.slice.call(arguments);if(["track","screen","alias","group","page","identify"].indexOf(e)>-1){var c=document.querySelector("link[rel='canonical']");n.push({__t:"bpc",c:c&&c.getAttribute("href")||void 0,p:location.pathname,u:location.href,s:location.search,t:document.title,r:document.referrer})}n.unshift(e);analytics.push(n);return analytics}};for(var n=0;n<analytics.methods.length;n++){var key=analytics.methods[n];analytics[key]=analytics.factory(key)}analytics.load=function(key,n){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.setAttribute("data-global-segment-analytics-key",i);t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(t,r);analytics._loadOptions=n};analytics._writeKey="${import.meta.env.VITE_SEGMENT_WRITE_KEY}";;analytics.SNIPPET_VERSION="5.2.0";analytics.load("${import.meta.env.VITE_SEGMENT_WRITE_KEY}");analytics.page();}}();`;
	document.head.appendChild(script);
}

const router = getRouter();

// Register the router instance for type safety
declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}

export const App = () => {
	return <RouterProvider router={router} />;
};
